export enum DbMigrationKind {
    NEW_DATABASE = 0,
    NEW_MODEL = 20,
    NEW_COLUMN = 40,
    UPDATE_COLUMN = 41,
    DELETE_COLUMN = 42,
    NEW_RELATION = 60,
    NEW_INDEX = 80
}
